import * as React from "react";
import { IconProps } from "./IconProps";

export const IconArrowTop2 = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="Group">
          <path
            id="Vector"
            d="M5.98617 0.500001C5.65517 0.499502 5.34017 0.641213 5.12167 0.889208L0.216168 6.45386C-0.111832 6.84356 -0.0608325 7.42488 0.330168 7.75221C0.708167 8.06856 1.26867 8.03264 1.60267 7.67087L5.89217 2.8048C5.93767 2.75291 6.01667 2.74792 6.06867 2.79332C6.07267 2.79682 6.07667 2.80081 6.08017 2.8048L10.3697 7.67087C10.6977 8.06058 11.2802 8.11148 11.6707 7.78464C12.0612 7.45731 12.1122 6.876 11.7847 6.48629C11.7757 6.47531 11.7662 6.46483 11.7562 6.45386L6.85217 0.891203C6.63317 0.64271 6.31767 0.5005 5.98617 0.500001Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
